
<template>
    <div class="forgotpassword">
        <v-container>
          <v-row class="text-center" align="center" align-self="center">

            <v-col md="6" offset-md="3">
              <v-card class="overflow-hidden mt-12" >
                  <v-toolbar flat color="secondary">

                    <v-toolbar-title class="font-weight-light white--text" >
                      {{$t('administration.user.forgotpassword')}}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-subtitle>
                    {{$t('administration.user.forgotpasswordmessage')}}
                  </v-card-subtitle>
                  <ForgotPasswordForm ref="ForgotPasswordForm" :values="item" :errors="violations" />
                  <v-divider></v-divider>
                  <v-card-actions class="pa-6">
                    <v-btn
                      @click="back"

                    >
                      {{$t('global.cancel')}}
                    </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="send"
                        color="primary"
                      >
                        {{$t('global.send')}}
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
       </v-container>
       <Loading :visible="isLoading" />
    </div>
</template>
<script>
  import { createHelpers } from 'vuex-map-fields';
  import { mapActions, mapState } from 'vuex';
  import ForgotPasswordForm from '../../components/login/ForgotPassword.vue';
  import Loading from '../../components/Loading';
  import NotificationMixin from '../../mixins/NotificationMixin';

  const servicePrefix = 'User';

  const { mapFields } = createHelpers({
    getterType: 'user/getField',
    mutationType: 'user/updateField'
  });

  export default {
    name: 'ForgotPassword',
    servicePrefix,
    mixins: [NotificationMixin],
    components: {
      Loading,
      ForgotPasswordForm
    },
    computed: {
      ...mapFields(['error', 'isLoading', 'created', 'violations']),
      ...mapState('user', {
        actioned: 'actioned',
        action: 'action',
        error: 'error',
        isLoading: 'isLoading',
      })
    },
    data() {
      return {
        item: {}
      };
    },
    created: function(){
      if (this.$root.isConnected) {
        this.$router.push({ name: `Home` });
      }
    },
    methods: {
      back() {
        this.$router.push({ name: `Login` });
      },
      send() {

        const ForgotPasswordForm = this.$refs.ForgotPasswordForm;
        ForgotPasswordForm.$v.$touch();
        if (!ForgotPasswordForm.$v.$invalid) {
          this.userPushAction({action: 'forgot_password',values: {'login' :ForgotPasswordForm.$v.item.$model.login}});

        } else {
          console.log('error');
        }
      },
      ...mapActions({
        userPushAction: 'user/action'
      }),

      sended(item) {
        console.log("sended");
        this.showMessage(item.message);
      },

    },
    watch: {
      actioned(actioned) {
        if (!actioned) {
          return;
        }
        if (this.action == 'forgot_password') {
          this.sended(actioned);
        }
      },

      error(message) {
        message && this.showError(message);
      }
    }
  }
</script>
